// These match the server's rules for tags
export const TAG_MAX_LENGTH = 50;
export const TAGS_MAX_COUNT = 20;

/**
 * Turn some typed text into a tag: tags are lowercase, and can only contain
 * letters, numbers, hyphens and underscores
 */
export function normaliseTag(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, '')
    .slice(0, TAG_MAX_LENGTH);
}

/**
 * Get a search query that finds everything with a tag
 */
export function tagSearchQuery(tag: string): string {
  return `#${tag}`;
}
